export const ESSENTIALS = "Cisco U. Essentials";
export const ALLACCESS = "Cisco U. All Access";
export const FREE = "Cisco U. Free";

export default {
  ESSENTIALS,
  ALLACCESS,
  FREE,
};
